import { render, staticRenderFns } from "./TVShowTracking.vue?vue&type=template&id=1e9a6532"
import script from "./TVShowTracking.vue?vue&type=script&setup=true&lang=ts"
export * from "./TVShowTracking.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports